import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";

import Carousel from "../Carousel/Carousel";
import Grid from "../Grid/Grid"
import TopBannerNew from "../TopBannerNew/TopBannerNew";
import { Loading } from "../Loading/Loading";

import { Big } from "../../styles/typography/typography";
import { HOST } from "../../store/types";

import i18n from "i18next";

import styled from "styled-components";

const ContainerLoadingSt = styled.div`
  ${props => props.preloader ? "opacity: 0; height: 0; overflow: hidden;" : "opacity: 1; height: auto; overflow: visible;"}
`

const TextSt = styled(Big)`
  display: block;
  margin: 50px 0;
  font-weight: 400;
`


const GetCards = (props) => {
    const {
        cardDisplayType, type, getChannelContent, title, tile, page, link, render, filter, past,
        chooseCard, showFilter, description, widthCard, _getallchooseCard, plug, isMobile, contentType,
        sourceCards,
    } = props;

    const [cards, setCards] = useState([]); // массив со всеми картами для карусели
    const [titleCard, setTitleCard] = useState("");
    const [descriptionCards, setDescriptionCards] = useState("");
    const [preloader, setPreloader] = useState(true);
    const [alsoRecommend, setAlsoRecommend] = useState([]);
    const [redirect, setRedirect] = useState(false);

    const token = useSelector((store) => store.auth.dataToken.token);

    // актуальные пропсы для асинхронного колбэка, чтобы не перезапускать запрос
    const propsRef = useRef(props);
    propsRef.current = props;

    // защита от setState после размонтирования
    const isMounted = useRef(true);
    useEffect(() => () => { isMounted.current = false }, []);

    // Получаем содержимое Card. Запрос выполняется один раз при монтировании,
    // как и в классовой версии (componentDidMount)
    useEffect(() => {
        const list = sourceCards;
        let bearer;
        if (token) {
            bearer = 'Bearer ' + token
        }

        const timers = [];

        fetch(`${HOST}/v1/${list}`, {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Authorization': bearer,
                'Content-Type': 'application/json'
            }
        })
            .then((res) => {
                return res.json();
            })
            .then((body) => {
                const p = propsRef.current;

                if (body.message) { //404 редирект
                    if (isMounted.current) setRedirect(true);
                }

                let newArray = [];
                let newAlsoRecommend = [];
                // обработка ответа подборок для мероприятий
                if (p.getSelections || p.page === "collections" || p.page === "collection") {
                    try {
                        Object.values(body.data.projects).map((item) => {
                            return (newArray.push(item))
                        })
                        if (isMounted.current) {
                            setTitleCard(body.data.title);
                            setDescriptionCards(body.data.description);
                        }
                    } catch (e) { }
                }
                // обработка ответа контента канала
                else if (p.getChannelContent) {
                    if (body[0]) {
                        if (body[p.getChannelContent[0]]) {
                            body[p.getChannelContent[0]].data.map((item, i) => {
                                return (newArray.push(item))
                            })
                            if (isMounted.current) {
                                setTitleCard(body[p.getChannelContent[0]].name);
                            }
                        }
                    }

                }
                // обработка избранного
                else if (p.page === "favorites" && p.type === "catalog") {
                    if (token) {
                        body.project.map((item) => {
                            return (newArray.push(item))
                        })
                    }
                }
                else if (p.page === "favorites" && p.type === "events") {
                    if (token) {
                        body.event.map((item, i) => {
                            return (newArray.push(item))
                        })
                    }
                }
                else if (p.page === "favorites" && p.type === "collections") {
                    if (token) {
                        body.collection.map((item, i) => {
                            return (newArray.push(item))
                        })
                    }
                }
                //
                else if (p.sourceCards === "slides") {
                    if (p.contentType === 'event' || p.contentType === 'мероприятие') {
                        body.data.map((item) => {
                            if (item.type === p.contentType) {
                                return (newArray.push(item))
                            }
                        })
                    }
                    else {
                        body.data.map((item, i) => {
                            return (newArray.push(item))
                        })
                    }
                }
                // обработка обычного ответа
                else {
                    if (p.filter) {
                        body.recommended_projects && body.recommended_projects.map((item) => {
                            return (newAlsoRecommend.push(item))
                        })
                    }
                    body.data.map((item, i) => {
                        if (p.contentType && item.type === p.contentType) {
                            return (newArray.push(item))
                        }
                        else if (!p.contentType) {
                            return (newArray.push(item))
                        }
                    })
                }

                if (isMounted.current) {
                    setCards(newArray);
                    setAlsoRecommend(newAlsoRecommend);
                }

                return newArray;
            })
            .then((newArray = []) => {
                const p = propsRef.current;

                if (p._countCards) {
                    p._countCards(newArray.length);
                }
                if (p._getCards) {
                    p._getCards(newArray.map((item) => {
                        return { title: item.title, id: item.id };
                    }));
                }
                timers.push(setTimeout(() => {
                    if (isMounted.current) setPreloader(false);
                }, 300));
            });

        return () => { timers.forEach(clearTimeout) };
        // запрос делается только при монтировании — остальные пропсы читаются через propsRef
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //редирект на 404
    if (redirect) { return <Redirect to='/404' />; }

    return (
        <>
            {/* Тип контейнера "carousel" */}
            {(preloader && cardDisplayType === "carousel") && <Loading />}
            {(cardDisplayType === "carousel" && cards.length > 0) &&
                <ContainerLoadingSt preloader={preloader}>
                    <Carousel
                        type={type}
                        title={getChannelContent ? titleCard : title}
                        description={descriptionCards}
                        cards={cards}
                        cardsLength={cards}
                        tile={tile}
                        page={page}
                        link={link}
                        render={render && render}
                    />
                </ContainerLoadingSt>
            }

            {/* Тип контейнера "grid" */}
            {(preloader && cardDisplayType === "grid") && <Loading />}
            {(filter && !preloader && cards.length === 0) &&
                <TextSt>{i18n.t(`filter.no_matches_for_your_request`)}.<br />{i18n.t(`filter.try_other_settings`)} :)</TextSt>}
            {(cardDisplayType === "grid" && cards.length > 0) &&
                <>
                    <ContainerLoadingSt preloader={preloader}>
                        <Grid
                            type={type}
                            title={titleCard ? titleCard : title}
                            description={descriptionCards ? descriptionCards : description}
                            past={past}
                            cards={cards}
                            cardsLength={cards}
                            tile={tile}
                            chooseCard={chooseCard}
                            showFilter={showFilter}
                            filter={filter}
                            page={page}
                            link={link}
                            widthCard={widthCard}
                            _getallchooseCard={_getallchooseCard}
                        />
                    </ContainerLoadingSt>
                </>
            }

            {/* Тип контейнера "grid", рекомендации только для компонента фильтр */}
            {filter && <ContainerLoadingSt>
                <Grid
                    type={type}
                    title={i18n.t(`filter.we_also_recommend`)}
                    description={descriptionCards ? descriptionCards : description}
                    past={past}
                    cards={alsoRecommend}
                    tile={tile}
                    chooseCard={chooseCard}
                    showFilter={showFilter}
                    filter={filter}
                    page={page}
                    link={link}
                    widthCard={widthCard}
                    _getallchooseCard={_getallchooseCard}
                />
            </ContainerLoadingSt>}

            {/* Тип контейнера "topbanner" */}
            {cardDisplayType === "topbanner" &&
                <TopBannerNew
                    banners={cards}
                    plug={plug}
                    isMobile={isMobile}
                    contentType={contentType}
                />
            }
        </>
    );
};

export default GetCards;
